// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validatePeruvianCity(cityValue: string): ?UserInputValidationError {
  return cityValue ? VALID : { id: 'empty' };
}
